





































import { Vue, Component } from 'vue-property-decorator';
import baseSpinner from '@/components/Spinner';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';

import imagesView from '@/mixins/Embroidery/ImagesView';

@Component({
  components: {
    baseSpinner,
    CustomContainer,
    CustomImage,
  },
  mixins: [imagesView],
})
export default class EmbroideryImagesView extends Vue {}
